<div mdbModal #asignarCamionRutas="mdb-modal" class="modal fade" id="dvModalAsignarCamionRutas" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" style="max-width:900px;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          {{!edicionRecorrido? 'Asignar Camión' : 'Editar Rutas'}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body justify-content-between">
          <div class="table-striped" *ngIf="listadoCamionChoferDisponible">
            <!-- <div *ngIf="selected">
              {{selected | json}}
            </div> -->
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Sel.</th>
                  <th scope="col"></th>
                  <th scope="col">N° Recorrido</th>
                  <th scope="col">Patente</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Descripción</th>
                  <th scope="col">Chofer</th>
                  <th scope="col">Total documentos</th>
                  <th scope="col">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <tr *ngIf="!loading && listadoCamionChoferDisponible?.length === 0">
                  <td colspan="100%" style="text-align: center">
                    No se encontró información
                  </td>
                </tr>
                <tr *ngFor="let camChofDisp of listadoCamionChoferDisponible; let i = index;">
                  <mdb-checkbox name="camion{{camChofDisp.recorrido_codigo}}"
                    [checked]="listadoCamionChoferDisponible[i].checked" (change)="checkItem(camChofDisp, $event)">
                    <!-- [checked]="listadoCamionChoferDisponible[i].checked" -->
                    <!-- (change)="listadoCamionChoferDisponible[i].checked= !listadoCamionChoferDisponible[i].checked;SoloUnCheck(camChofDisp)" -->
                  </mdb-checkbox>
                  <td [style.backgroundColor]="camChofDisp.color">{{''}}</td>
                  <td>{{ camChofDisp.recorrido_codigo }}</td>
                  <td>{{ camChofDisp.patente }}</td>
                  <td>{{ camChofDisp.fecha | fecha }}</td>
                  <td>{{ camChofDisp.descripcion_camion }}</td>
                  <td>{{ camChofDisp.nombre_chofer }}</td>
                  <td>$ {{ camChofDisp.total_facturas | numerico }}</td>
                  <td>
                    <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                      (click)="editarRecorrido(camChofDisp)" mdbTooltip="Editar" placement="right">
                      <mdb-icon fas icon="pen"></mdb-icon>
                    </button>
                    <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                      (click)="confirmEliminar(camChofDisp)" mdbTooltip="Eliminar" placement="right"
                      [disabled]="camChofDisp.total_facturas > 0">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listadoCamionChoferDisponibleAll?.length > 0"></app-pagination>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="cerrarModal()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" *ngIf="edicionRecorrido" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="ClonarRecorrido();">
          Clonar
        </button>
        <button size="sm" class="btn btn-sm btn-secondary waves-light" type="button" mdbWavesEffect data-toggle="modal"
          data-target="#dvModalAsignarCamionRutas" (click)="requestShowModalRutas()" placement="right">
          Crear Ruta
        </button>
        <app-api-button *ngIf="!edicionRecorrido" type="button" mdbWavesEffect (click2)="AsignarCamion();"
          [processing]="processing">
          Guardar
        </app-api-button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL CREAR RUTA -->
<app-modal-add-edit-ruta (onSuccess)="onCargarRuta()"></app-modal-add-edit-ruta>

<app-modal-clonar-recorrido (onAccept)="UpdateEditarRutas();"></app-modal-clonar-recorrido>

<app-modal-confirm>
</app-modal-confirm>